module.exports = __webpack_public_path__ + "img/register.95694a78.svg";